import styles from "./styles.module.scss";
import Section from "../../../components/Section";
import figma_icon from "../../../graphics/figma_icon.svg";
import plus_icon from "../../../graphics/plus_icon.svg";
import left_icon from "../../../graphics/left_icon.svg";
import headphone_icon from "../../../graphics/headphone_icon.svg";
import book_icon from "../../../graphics/book_icon.svg";
import mark_icon from "../../../graphics/mark_icon.svg";
import add_icon from "../../../graphics/add_icon.svg";
import point_icon from "../../../graphics/point_icon.svg";

import book_1 from "../../../images/book_1.png";
import book_2 from "../../../images/book_2.png";
import book_3 from "../../../images/book_3.png";
import book_4 from "../../../images/book_4.png";
import book_5 from "../../../images/book_5.png";
import book_6 from "../../../images/book_6.png";
import book_display from "../../../images/book_display.png";

import { useEffect } from "react";

const Books = () => {
  useEffect(() => {
    function OTPInput() {
      const inputs = document.querySelectorAll("#otp > *[id]");
      for (let i = 0; i < inputs.length; i++) {
        inputs[i].addEventListener("keydown", function (event) {
          if (event.key === "Backspace") {
            inputs[i].value = "";
            if (i !== 0) inputs[i - 1].focus();
          } else {
            if (i === inputs.length - 1 && inputs[i].value !== "") {
              return true;
            } else if (event.keyCode > 47 && event.keyCode < 58) {
              inputs[i].value = event.key;
              if (i !== inputs.length - 1) inputs[i + 1].focus();
              event.preventDefault();
            } else if (event.keyCode > 64 && event.keyCode < 91) {
              inputs[i].value = String.fromCharCode(event.keyCode);
              if (i !== inputs.length - 1) inputs[i + 1].focus();
              event.preventDefault();
            }
          }
        });
      }
    }

    OTPInput();
  }, []);

  return (
    <>
      <Section>
        <h2 className={styles.title}>
          Приложение для чтения книг онлайн и офлайн
        </h2>
        <div className={styles.container}>
          <div className={styles.content}>
            <div className={styles.item}>
              <h4 className={styles.subtitle}>Бизнес-задача</h4>
              <p className={styles.text}>
                Создать приложение, которое поможет привлечь аудиторию к
                бесплатному чтению книг и повысить узнаваемость компании на
                рынке.
              </p>
            </div>

            <div className={styles.item}>
              <h4 className={styles.subtitle}>Процесс решения</h4>
              <p className={styles.text}>
                Фокус был на простом и удобном интерфейсе, где можно легко найти
                нужную книгу. Спроектировала интерфейс для комфортного чтения и
                аудио прослушивания, добавила функции избранного произведения.
              </p>
            </div>
          </div>

          <div className={styles.images}>
            <div className={styles.item}>
              <img src={book_1} alt="" />
            </div>
            <div className={styles.item}>
              <img src={book_2} alt="" />
            </div>
            <div className={styles.item}>
              <img src={book_3} alt="" />
            </div>
            <div className={styles.item}>
              <img src={book_4} alt="" />
            </div>
            <div className={styles.item}>
              <img src={book_5} alt="" />
            </div>
            <div className={styles.item}>
              <img src={book_6} alt="" />
            </div>
          </div>

          <div className={styles.design_system}>
            <div className={styles.section}>
              <h4 className={styles.subtitle_button}>Button</h4>
              <div className={styles.border_container}>
                <div className={styles.buttons}>
                  <div className={styles.col}>
                    <button data-name="default">Войти</button>
                    <button className={styles.default_border}>
                      Создать новый аккаунт
                    </button>
                    <button>Продолжить</button>
                    <button className={styles.default_border}>Готово</button>
                  </div>
                  <div className={styles.col}>
                    <button data-name="active" className={styles.active}>
                      Войти
                    </button>
                    <button className={styles.active_border}>
                      Создать новый аккаунт
                    </button>
                    <button className={styles.active}>Продолжить</button>
                    <button className={styles.active_border}>Готово</button>
                  </div>
                  <div className={styles.col}>
                    <button
                      data-name="disabled"
                      disabled
                      className={styles.disabled}
                    >
                      Войти
                    </button>
                    <button disabled className={styles.disabled}>
                      Создать новый аккаунт
                    </button>
                    <button disabled className={styles.disabled}>
                      Продолжить
                    </button>
                    <button disabled className={styles.disabled}>
                      Готово
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.column}>
              <div className={styles.section}>
                <h4 className={styles.subtitle}>Color palette</h4>
                <div className={styles.palette_container}>
                  <div
                    className={styles.palette}
                    style={{ backgroundColor: "#1D1D1D" }}
                  >
                    <p>
                      Black <br /> #1D1D1D
                    </p>
                  </div>
                  <div
                    className={styles.palette}
                    style={{ backgroundColor: "#8C5F34" }}
                  >
                    <p>
                      Braun
                      <br /> #8C5F34
                    </p>
                  </div>
                  <div
                    className={styles.palette}
                    style={{ backgroundColor: "#626262" }}
                  >
                    <p>
                      Gray
                      <br />
                      #626262
                    </p>
                  </div>
                  <div
                    className={styles.palette}
                    style={{ backgroundColor: "#868686" }}
                  >
                    <p>
                      Light-gray <br /> #868686
                    </p>
                  </div>
                  <div
                    className={styles.palette}
                    style={{ backgroundColor: "#FFFFFF" }}
                  >
                    <p>
                      White <br /> #FFFFFF
                    </p>
                  </div>
                </div>
              </div>

              <div className={styles.section}>
                <h4 className={styles.subtitle}>Fonts</h4>
                <div className={styles.fonts}>
                  <div>
                    <h5 className={styles.generic_subtitle}>font family</h5>
                    <div className={styles.fonts_container}>
                      <div className={styles.font}>
                        <div className={styles.montserrat}>
                          <p className={styles.colored}>Aa</p>
                          <p>Montserrat</p>
                        </div>
                      </div>
                      <div className={styles.font}>
                        <div className={styles.raleway}>
                          <p className={styles.colored}>Aa</p>
                          <p>Raleway</p>
                        </div>
                      </div>
                      <p className={styles.font_text}>Aa</p>
                    </div>
                  </div>

                  <div>
                    <h5 className={styles.generic_subtitle}>font weight</h5>
                    <div className={styles.fonts_container}>
                      <div className={styles.font} style={{ fontWeight: 400 }}>
                        <div className={styles.montserrat}>
                          <p className={styles.colored}>Aa</p>
                          <p>Regular</p>
                        </div>
                      </div>
                      <div className={styles.font} style={{ fontWeight: 600 }}>
                        <div className={styles.montserrat}>
                          <p className={styles.colored}>Aa</p>
                          <p>SemiBold</p>
                        </div>
                      </div>
                      <div className={styles.font} style={{ fontWeight: 700 }}>
                        <div className={styles.montserrat}>
                          <p className={styles.colored}>Aa</p>
                          <p>Bold</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h5 className={styles.generic_subtitle}>font size</h5>
                    <div className={styles.font_size}>
                      <p>H1</p>
                      <p>Bold</p>
                      <p>24px</p>
                      <h1>The word</h1>

                      <p>H2</p>
                      <p>SemiBold</p>
                      <p>22px</p>
                      <h2>The word</h2>

                      <p>H3</p>
                      <p>SemiBold</p>
                      <p>20px</p>
                      <h3>The word</h3>

                      <p>H4</p>
                      <p>SemiBold</p>
                      <p>18px</p>
                      <h4>The word</h4>

                      <p>H5</p>
                      <p>Regular</p>
                      <p>16px</p>
                      <h5>The word</h5>

                      <p>body</p>
                      <p>Regular</p>
                      <p>14px</p>
                      <p>The word</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.column}>
              <div className={`${styles.section} ${styles.input_section}`}>
                <h4 className={`${styles.subtitle} ${styles.input_subtitle}`}>
                  Input
                </h4>
                <div className={styles.border_container}>
                  <div className={styles.inputs}>
                    <div className={styles.input}>
                      <p className={styles.helper_text}>default</p>
                      <label htmlFor="input1">Label</label>
                      <input id="input1" type="text" />
                    </div>

                    <div className={styles.input}>
                      <p className={styles.helper_text}>hover</p>
                      <label htmlFor="input2">Label</label>
                      <input className={styles.hover} id="input2" type="text" />
                    </div>

                    <div className={styles.input}>
                      <p className={styles.helper_text}>error</p>
                      <label htmlFor="input3">Label</label>
                      <input className={styles.error} id="input3" type="text" />
                      <span>ERROR TEXT</span>
                    </div>

                    <div className={styles.input}>
                      <p className={styles.helper_text}>focus</p>
                      <label htmlFor="input4">Label</label>
                      <input
                        defaultValue="Entered te"
                        className={styles.focus}
                        id="input4"
                        type="text"
                      />
                    </div>

                    <div className={styles.input}>
                      <p className={styles.helper_text}>placeholder</p>
                      <label htmlFor="input5">Label</label>
                      <input
                        placeholder="Entered text"
                        id="input5"
                        type="text"
                      />
                    </div>

                    <div className={styles.input}>
                      <p className={styles.helper_text}>with data</p>
                      <label htmlFor="input6">Label</label>
                      <input
                        defaultValue="Entered text"
                        id="input6"
                        type="text"
                      />
                    </div>

                    <div className={styles.input}>
                      <p className={styles.helper_text}>disabled</p>
                      <label htmlFor="input7">Label</label>
                      <input disabled id="input7" type="text" />
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.section}>
                <h4 className={styles.subtitle}>Layout Grid</h4>
                <div className={styles.grid}>
                  <p>4 columns</p>
                  <p>100 margin</p>
                  <p>20 gutter</p>
                </div>
              </div>
            </div>

            <div className={styles.section}>
              <h4 className={styles.subtitle}>Components</h4>
              <div className={styles.components}>
                <div className={styles.col}>
                  <div>
                    <h5 className={styles.generic_subtitle}>search bar</h5>

                    <div className={styles.border_container}>
                      <div className={styles.search_bar}>
                        <div>
                          <input placeholder="Поиск" type="text" />
                          <div className={styles.heading}>
                            <div className={styles.button}>
                              <img src={left_icon} alt="" />
                              Назад
                            </div>
                            <div className={styles.sub_title}>Заголовок</div>
                            <div className={styles.button}>
                              <img src={plus_icon} alt="" />
                            </div>
                          </div>
                          <input placeholder="Поиск" type="text" />
                        </div>
                        <div className={styles.display}>
                          <div>
                            <p className={styles.hint}>Подсказка</p>
                            <div className={styles.heading}>
                              <div className={styles.button}>Отмена</div>
                              <div className={styles.sub_title}>Заголовок</div>
                              <div className={styles.button}>Готово</div>
                            </div>
                            <input placeholder="Поиск" type="text" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.col}>
                  <div>
                    <h5 className={styles.generic_subtitle}>
                      segmented control
                    </h5>
                    <div className={styles.border_container}>
                      <div className={styles.segment_control}>
                        <span>Книги</span>
                        <span>Преподаватели</span>
                        <span>Курсы</span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <h5 className={styles.generic_subtitle}>OTP form</h5>
                    <div className={styles.border_container}>
                      <div id="otp" className={styles.otp}>
                        <input
                          defaultValue="3"
                          type="text"
                          id="first"
                          maxLength="1"
                        />
                        <input
                          defaultValue="0"
                          type="text"
                          id="second"
                          maxLength="1"
                        />
                        <input
                          defaultValue="4"
                          type="text"
                          id="third"
                          maxLength="1"
                        />
                        <input
                          defaultValue="1"
                          type="text"
                          id="fourth"
                          maxLength="1"
                        />
                      </div>
                    </div>
                  </div>
                  <div className={styles.row}>
                    <div>
                      <h5 className={styles.generic_subtitle}>switch</h5>
                      <div className={styles.border_container}>
                        <div className={styles.switch}>
                          <div>
                            <img src={book_icon} alt="" />
                            <p>текст</p>
                          </div>
                          <div>
                            <img src={headphone_icon} alt="" />
                            <p>аудио</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <h5 className={styles.generic_subtitle}>page control</h5>
                      <div className={styles.border_container}>
                        <div className={styles.page_control}>
                          <div />
                          <div />
                          <div />
                          <div />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.col}>
                  <div>
                    <h5 className={styles.generic_subtitle}>button icon</h5>

                    <div className={styles.border_container}>
                      <div className={styles.button_icon}>
                        <button>
                          <img src={add_icon} alt="" />
                        </button>
                        <div>
                          <button>
                            <img src={point_icon} alt="" />
                          </button>
                          <button>
                            <img src={mark_icon} alt="" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Section>
      <Section color="#E2E2E2" style={{ position: "relative" }}>
        <div className={styles.block} />
        <div className={styles.display_img}>
          <img src={book_display} alt="" />
        </div>
      </Section>
    </>
  );
};

export default Books;
